import React from "react";
import { Pagination } from "@components";
import { Input,  Select } from "@components/form";
import {  FormProvider } from 'react-hook-form';
import { useNavigate} from 'react-router-dom';
import { useLecture } from "@hooks";
const Lecture = () => {
  const {
    methods, lectureList, categoryList, eduTypeList,
    selectedItems, isAllChecked, onSubmit,
    handlePageChange, handleSelectAll, handleSelectItem, handleDelete, resetSearch,
    pageIndex, recordCountPerPage,
  } = useLecture();


  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();
    navigate('/master/lectureForm');
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        alert("수정할 항목을 선택해주세요.");
        return;
    } else if (selectedItems.length > 1) {
        alert("수정은 한 개 항목만 가능합니다.");
        return;
    }
    navigate('/master/lectureForm', {state: {selectedLectureId: selectedItems[0], isEdit: true}});
  }

  const handleRowClick = (lectureId) => {
      navigate(`/master/lecture/${lectureId}`);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>강의 정보</h2>
          </div>

          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item">
                    <label>강의년도</label>
                    <Select
                        name="catgRegYear"
                        options={[
                          { key: "2025", name: "2025년" },
                          { key: "2026", name: "2026년" },
                          { key: "2027", name: "2027년" },
                        ]}
                        defaultOption="전체"
                        className="input-select"
                      />
                    <label style={{marginLeft:"20px"}}>강의분류</label>
                    <Select
                        name="eduCategoryId"
                        options={categoryList?.result}
                        defaultOption="전체"
                        valueKey="eduCategoryId"
                        labelKey="eduCategoryNm"
                        className="input-select"
                      />                    
                      <label style={{marginLeft:"20px"}}>강의유형</label>
                      <Select
                          name="comdCode"
                          options={eduTypeList?.result}
                          valueKey="comdCode"  
                          labelKey="comdName"                          
                          defaultOption="전체"
                          className="input-select"
                        />
                    <label style={{marginLeft:"20px"}}>조회 조건</label>
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "강의명" },
                        { key: "1", name: "강의날짜" },
                      ]}
                      defaultOption="전체"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "250px" }}
                    />
                  </div>
                  <div className="search-btn-container">
                    <button type="submit" className="btn-search">조회</button>
                    <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
                  </div>
                </div>
              </div>

                <section className="section-wrap">
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;강의 목록
                      <span className="total-txt">
                        {" "} | 총 <span className="red">{lectureList?.totalCount}</span> 건
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button title="등록" className="btn-write"  onClick={handleRegister}>등록</button></li>
                        <li><button title="수정" className="btn-update"  onClick={handleUpdate} >수정</button></li>
                        <li><button title="삭제" className="btn-delete" onClick={handleDelete}>삭제</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                    <table className="table-list" style={{width:"100%"}}>
                      <colgroup>
                        <col style={{ width: "1%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th> <input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} /> </th>
                          <th>번호</th>
                          <th>강의분류</th>
                          <th>강의명</th>
                          <th>신청기간</th>
                          <th>강의날짜</th>
                          <th>출강사업장</th>
                          <th>수강정원</th>
                          <th>수강료</th>
                          <th>강의유형</th>
                          <th>강의상태</th>
                        </tr>
                      </thead>
                      <tbody>
                      {lectureList?.resultList && lectureList.resultList.length > 0 ? (
                        lectureList.resultList.map((item, idx) => (
                          <tr 
                              key={item.lectureId}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleRowClick(item.lectureId)}>
                            <td onClick={(e) => e.stopPropagation()}>
                              <input 
                                type="checkbox" 
                                checked={selectedItems.includes(item.lectureId)} 
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(item.lectureId)
                                }} />
                            </td>
                            <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                            <td style={{textAlign:"left"}}>
                              {/* {"["}{item.catgRegYear}{"]"} {item.eduCategoryNm} {item.eduNo}차 */}
                              {/* {[`[${item.catgRegYear}]`, item.eduCategoryNm, `(${item.eduHours}시간)`, ` - ${item.eduNo}차`,].join(" ")} */}
                              {[`[${item.catgRegYear}년`, `${item.eduNo}차]`, item.eduCategoryNm, `(${item.eduHours}시간)`,].join(" ")}
                            </td>
                            <td style={{textAlign:"left"}}>{item.lectureNm}</td>
                            <td>{item.applyStartDt} ~ {item.applyEndDt}</td>
                            <td>{item.firstDt} {item.lastDt && ` ~ ${item.lastDt}`}</td>
                            <td>{item.companyNm}</td>
                            <td>{item.curStudentCnt}/{item.eduStdntLimit}</td>
                            <td>{item.eduPee?.toLocaleString('ko-KR', { style: 'currency', currency: 'KRW' })}</td>
                            <td>{item.eduTypeNm}</td>
                            <td>{item.lectureStatusNm}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={11} style={{ textAlign: 'center' }}>
                            조회 결과가 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    </table>
                  </div>
                  {lectureList?.paginationInfo && lectureList.paginationInfo.totalRecordCount > 0 && (
                      <Pagination
                          totalPages={Math.ceil(
                            lectureList.paginationInfo.totalRecordCount / lectureList.paginationInfo.recordCountPerPage
                          )}
                          currentPage={pageIndex}
                          onPageChange={handlePageChange}
                          pageRangeDisplayed={10}
                      />
                      )}
                </section>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export {Lecture};
